
import { Component, Mixins } from "vue-property-decorator";
import { IDateComparisonExpressionBehavior } from "../../../../../../documaker/domain/format/objects";
import { IDateComparisonExpressionBehaviorPropertyEditable, instanceOfIDateComparisonExpressionBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class DateComparisonExpressionBehaviorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IDateComparisonExpressionBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IDateComparisonExpressionBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isDateComparisonExpressionBehaviorPropertyEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIDateComparisonExpressionBehaviorPropertyEditable(s) && s.dateComparisonExpressionBehavior().isEditable(), false);
  }

  get dateComparisonExpressionBehavior(): IDateComparisonExpressionBehavior {
    return this.readPropertyOrDefault(s => s.dateComparisonExpressionBehavior().getValue(), { contents: []});
  }

  set dateComparisonExpressionBehavior(value: IDateComparisonExpressionBehavior) {
    this.writePropertyWhenValid(s => s.dateComparisonExpressionBehavior().setValue(value));
  }
}
